import { useHistory } from "react-router";
import { TemplateClassNames } from "../../../types/template-layouts";
import { LanguagesAbbr, ModuleMap, PageLinkType, PageModuleType } from "../../../types/working-model";
import { parseUrl } from "../../../utils/utils";
import { eventPath } from "../../live-event/utils";
import { Button } from "../button/button";
import classNames from 'classnames';
import './live-call-to-action.scss';

interface LiveCTAProps {
	classname: string;
	template: TemplateClassNames
	buttonText: string | string[];
	pageLink: PageLinkType | null;
	sectionLink: PageModuleType | null;
	urlLink: string | null;
	eventName: string | undefined;
	uuid: string | undefined;
	selectedLanguage: LanguagesAbbr;
	registration_on: boolean;
}

const LiveCallToAction: React.FC<LiveCTAProps> = ({
	classname,
	template,
	buttonText,
	pageLink,
	sectionLink,
	urlLink,
	eventName,
	uuid,
	selectedLanguage,
	registration_on
}) => {
	const history = useHistory();

	// FUTURE DEV: ideally, this function will not be needed because localhost dev will not have an event name
	// current brandlive-dev.com is not pulling the event name from the params correctly, so we're forcing it through the props
	// This ensures that an event name is always present, nullifying the eventPath() function. Once resolved, remove this function,
	// and replace the getEventName() calls with eventPath() calls
	function getEventName() {
		if (window.location.hostname === 'localhost')
			return eventPath(undefined, uuid);
		else
			return eventPath(eventName, uuid);
	}

	const handleClick = () => {
		if (pageLink) {
			switch (pageLink) {
				case PageLinkType.termsAndConditions: {
					history.push(`/${getEventName()}/${selectedLanguage}/terms-conditions`);
					return;
				}
				case PageLinkType.registration: {
					if (registration_on)
						history.push(`/${getEventName()}/${selectedLanguage}/registration`);
					else
						history.push(`/${getEventName()}/${selectedLanguage}/home`);
					return;
				}
				case PageLinkType.privacyPolicy: {
					history.push(`/${getEventName()}/${selectedLanguage}/privacy-policy`);
					return;
				}
				case PageLinkType.landing: {
					history.push(`/${getEventName()}/${selectedLanguage}/`);
					return;
				}
				case PageLinkType.homepage: {
					if (registration_on)
						history.push(`/${getEventName()}/${selectedLanguage}/registration`);
					else
						history.push(`/${getEventName()}/${selectedLanguage}/home`);
					return;
				}
				default: return;
			}
		}
		if (sectionLink) {
			document.getElementById(`${ModuleMap[sectionLink]}`)?.scrollIntoView({ behavior: 'smooth' });
			return;
		}
	};

	// if no button text, do not show the button
	if (!buttonText) return null;
	return (
		<>
			{urlLink ? (
				<a
					href={parseUrl(urlLink)}
					className={classNames('call-to-action-url', classname, template)}
				>
					{buttonText}
				</a>
			) : (
				<Button
					classButton={classname}
					template={template}
					onClick={handleClick}
				>{buttonText}</Button>
			)}
		</>

	);
};

export default LiveCallToAction;